// extracted by mini-css-extract-plugin
export default {"placeholder":"InquiryList_placeholder__AWD1K","bold":"InquiryList_bold__PxglJ"};